import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { Breadcrumbs, DateBasedChart, DynamicEntityIndex, GlobalLoader, NoData } from '@reactiveonline/reactive_admin_shared-packages'
import GlobalImports from '../shared/GlobalImports'
import PresetDateRangePicker from '../shared/PresetDateRangePicker'
import { truncateText } from '../../helpers/utils'

export default function RegistrationDetails({
  appProps, applicationTitle, breadcrumbs, entityPath, fetchRegistrationInfoPath, filters, flavour, exportRegistrationsPath, icon,
  listColumns, registrationIcon, registrationsPath, selectedColumns, tabs
}) {
  const [registrationData, setRegistrationData] = useState([])
  const [registrations, setRegistrations] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  const [loading, setLoading] = useState(false)
  const [renderKey, setRenderKey] = useState(0)
  const [dateRange, setDateRange] = useState({
    start_date: moment().subtract(30, 'days'),
    end_date: moment(new Date())
  })

  useEffect(() => {
    fetchData()
  }, [dateRange])

  const fetchData = () => {
    setLoading(true)

    Rails.ajax({
      type: 'GET',
      url: `${ fetchRegistrationInfoPath }?flavour=${ flavour }&date_range=${ JSON.stringify(dateRange) }`,
      dataType: 'json',
      success: res => {
        setLoading(false)
        setRegistrationData(res.registration_data)
        setRegistrations(res.items)
        setTotalPages(res.totalPages)
        setRenderKey(Math.random())
      }
    })
  }

  const handleApplyDateRange = updatedDateRange => {
    setDateRange(updatedDateRange)
  }

  const itemRenderer = (item, columns) => {
    return (
      <React.Fragment key={ item.apiUid }>
        { columns.map(column => {
          if (column.label === 'createdAt') {
            return (
              <div key={ column.label } className='item flex-1'>
                <a href={ `${ registrationsPath }/${ item.apiUid }` }>
                  { item[column.label] }
                </a>
              </div>
            )
          } else {
            return (
              <div key={ column.label } className='item flex-1'>
                { column.label === 'storeName' ? truncateText(item[column.label]) || '-' : item[column.label] || '-' }
              </div>
            )
          }
        })}
      </React.Fragment>
    )
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div style={{ width: '100%' }}>
          <div className='flex-box content-space-between'>
            <div className='page-header'>
              <i className={ `fa-light ${ icon }` }/>
              <h1 className='page-header-title'>
                { applicationTitle }
              </h1>
            </div>

            <div className='flex-box items-center'>
              <PresetDateRangePicker
                value={ dateRange }
                onApply={ handleApplyDateRange }
                maxDateRangeDays={ 365 }
              />
            </div>
          </div>

        <Breadcrumbs
          breadcrumbs={ breadcrumbs }
          wrapperHeader={ false }
          />
        </div>
      </div>

      <div className='card'>
        <div className='card-content'>
          <div className='card-body'>
            <div className='flex-box items-center content-center'>
              { registrationData.length > 0
                ? <DateBasedChart
                    data={ registrationData }
                    chartKey={ 'chartdiv1' }
                  />
                : <NoData
                    chartTitle={ Partners.translations.registration.no_registrations }
                  />
              }
            </div>
          </div>
        </div>
      </div>

      <DynamicEntityIndex
        key={ renderKey }
        initialItems={ registrations }
        initialTotalPages={ totalPages }
        disableDelete={ true }
        entity='registrations'
        filters={ filters }
        tabs={ tabs }
        tableHeadings={ selectedColumns }
        disableCustomization={ true }
        itemRenderer={ itemRenderer }
        itemsPath={ entityPath }
        icon={ registrationIcon }
        noResourcesTitle={ Partners.translations.registration.no_registrations }
        listColumns={ listColumns }
        columnTranslations={ Partners.translations.columns }
        fetchOnStart={ false }
        isExportable
        exportPath={ exportRegistrationsPath }
        selectAll={ true }
      />

      { loading && <GlobalLoader fullPage /> }
      <GlobalImports appProps={ appProps } />
    </>
  )
}
